module.exports = __webpack_public_path__ + "img/gs-monitor.95f113a8.png";